import { render, staticRenderFns } from "./MessagesHistory.vue?vue&type=template&id=71253e9c&scoped=true&"
import script from "./MessagesHistory.vue?vue&type=script&lang=ts&"
export * from "./MessagesHistory.vue?vue&type=script&lang=ts&"
import style0 from "./MessagesHistory.vue?vue&type=style&index=0&id=71253e9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71253e9c",
  null
  
)

export default component.exports